import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

//constantes
const dataInicial = {
    data: {
        data: []
    },
    error: null
}
//types
const OBTENER_DATOS_MAGUEY_EXITO = 'OBTENER_DATOS_MAGUEY_EXITO'

const OBTENER_DATOS_MAGUEY_BY_IDPREDIO_EXITO = 'OBTENER_DATOS_MAGUEY_BY_IDPREDIO_EXITO'
const AGREGAR_DATOS_MAGUEY_EXITO = 'AGREGAR_DATOS_MAGUEY_EXITO'

const ACTUALIZAR_DATOS_MAGUEY_EXITO = 'ACTUALIZAR_DATOS_MAGUEY_EXITO'

const ACTUALIZAR_DATOS_MAGUEY_REQ_EXITO = 'ACTUALIZAR_DATOS_MAGUEY_REQ_EXITO'
const OBTENER_DATOS_MAGUEY_BY_IDPREDIO_EDAD_EXITO = 'OBTENER_DATOS_MAGUEY_BY_IDPREDIO_EDAD_EXITO'
const ELIMINAR_DATOS_MAGUEY_REQ_EXITO = 'ELIMINAR_DATOS_MAGUEY_REQ_EXITO'
const OBTENER_DATOS_MAGUEY_BY_IDPREDIO_EXITO_EDICION = 'OBTENER_DATOS_MAGUEY_BY_IDPREDIO_EXITO_EDICION'

export const obtenerAllDatosMaguey = createAsyncThunk(
    OBTENER_DATOS_MAGUEY_EXITO,
    async () => {
        try {
            const fullUrl = host + `DatosMaguey/obtenerAllDatosMaguey`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const agregarDatosMaguey = createAsyncThunk(
    AGREGAR_DATOS_MAGUEY_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `DatosMaguey/agregarDatosMaguey`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)


export const actualizarDatosMaguey = createAsyncThunk(
    ACTUALIZAR_DATOS_MAGUEY_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `DatosMaguey/actualizarDatosMaguey`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)

export const actualizarDatosMagueyReq = createAsyncThunk(
    ACTUALIZAR_DATOS_MAGUEY_REQ_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `DatosMaguey/actualizarDatosMagueyReq`
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const obtenerDatosMagueyByIdPredio = createAsyncThunk(
    OBTENER_DATOS_MAGUEY_BY_IDPREDIO_EXITO,
    async (idPredio) => {
        try {
            const fullUrl = host + `DatosMaguey/obtenerDatosMagueyByIdPredio/${idPredio}`
            const result = await axios.get(fullUrl)
            let datos = []
            for (const i in result?.data?.data) {
                if (result?.data?.data?.[i].edad >= 5) {
                    datos.push(result?.data?.data?.[i])
                }
            }
            return { data: { data: datos } }
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerDatosMagueyByIdPredioAndEdad = createAsyncThunk(
    OBTENER_DATOS_MAGUEY_BY_IDPREDIO_EDAD_EXITO,
    async (idPredio) => {
        try {
            const fullUrl = host + `DatosMaguey/obtenerDatosMagueyByIdPredioAndEdad/${idPredio}`
            const result = await axios.get(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const eliminarDatosMagueyReq = createAsyncThunk(
    ELIMINAR_DATOS_MAGUEY_REQ_EXITO,
    async (id) => {
        try {
            const fullUrl = host + `DatosMaguey/eliminarDatosMaguey/${id}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
export const obtenerDatosMagueyByIdPredioEdicionDatos = createAsyncThunk(
    OBTENER_DATOS_MAGUEY_BY_IDPREDIO_EXITO_EDICION,
    async (idPredio) => {
        try {
            const fullUrl = host + `DatosMaguey/obtenerDatosMagueyByIdPredio/${idPredio}`
            const result = await axios.get(fullUrl)
            /*let datos = []
            for (const i in result?.data?.data) {
                datos.push(result?.data?.data?.[i])
            }*/
            var array = sortJSON(result?.data?.data, 'iddatosmaguey', 'asc');
            return { data: { data: array } }
        } catch (error) {
            console.log(error);
        }
    }
)
function sortJSON(data, key, orden) {
    return data.sort(function (a, b) {
        var x = a[key],
        y = b[key];

        if (orden === 'asc') {
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        }

        if (orden === 'desc') {
            return ((x > y) ? -1 : ((x < y) ? 1 : 0));
        }
    });
}
export const datMaguey = createSlice({
    name: 'datMaguey',
    initialState: dataInicial,
    reducers: {

    },
    extraReducers: {

        [obtenerAllDatosMaguey.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },
        [agregarDatosMaguey.fulfilled]: (state, { payload }) => {

        },

        [actualizarDatosMaguey.fulfilled]: (state, { payload }) => {

        },
        [actualizarDatosMagueyReq.fulfilled]: (state, { payload }) => {

        },

        [actualizarDatosMagueyReq.rejected]: (state, { payload }) => {
            state.error = payload.error
        },

        [actualizarDatosMaguey.rejected]: (state, { payload }) => {

            state.error = payload.error
        },
        [obtenerDatosMagueyByIdPredio.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },
        [obtenerDatosMagueyByIdPredioEdicionDatos.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },
        [obtenerDatosMagueyByIdPredioAndEdad.fulfilled]: (state, { payload }) => {
            state.data = payload.data
        },
    },
})

export const {
} = datMaguey.actions
export const DatosMagueyReducerUsuarioAgricola = datMaguey.reducer